import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '@shared/services/notifications-service/notification.service';
import { IAlertHistoryModel, IAlertModel } from '@shared/models/alerts/alerts.model';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { ScrollHandlingEventsEnum } from '@types-custom/models/ui/scroll-model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isoFormatDate } from '@shared/utils/functions/format-date';
import { IGridPageModel } from '@types-custom/models/ui/grid-page-model';
import { AbstractPanelManagementDataSource } from '@types-custom/models/ui/paginator-model';
import { gridTableheadersMap, GridTypeEnum } from '@shared/utils/mappers/grid-mapper';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { LocalStorageManagementService } from '@shared/services/local-storage-management/local-storage-management.service';

@Component({
  selector: 'ui-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  animations: [
    trigger('fadeInDown', [
      state('void', style({
        opacity: 0,
        transform: 'translateY(-20px)'
      })),
      transition('void => *', [
        animate('0.5s ease-out')
      ])
    ])
  ]
})
export class NotificationsComponent implements OnInit {

  public notifications : IAlertHistoryModel[]
  public panelActionsDispatcher!: BehaviorSubject<
    ScrollHandlingEventsEnum | undefined
  >;
  private subscription : Subscription

  gridPageProps: IGridPageModel;
  servicePanelDataSource: AbstractPanelManagementDataSource;
  gridColumnActions: Subject<IGridTableCellDispatcher>;

  layerName = 'ManageCameras' as GridTypeEnum;
  isAllowDownload = false;

  userId: string;

  constructor(
    private notificationService : NotificationService,
    private localStorageManagementService: LocalStorageManagementService
  ) {
  }

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.servicePanelDataSource = this.notificationService;
    // gridTableheadersMap([this.gridColumnActions])[this.layerName]
    this.gridPageProps = {
      headers: [
        { key: 'name', label: '' },
        { key: 'alertConfigName', label: '' }
      ],
      dataSource: this.servicePanelDataSource,
      isAllowDownload: this.isAllowDownload,
      isAllowDownloadExcel: false,
      isAllowDownloadPdf: false
    };

    this.localStorageManagementService.userInfo$.subscribe(
      (res) => (this.userId = res?.id)
    );

    this.servicePanelDataSource.init();

    // this.gridColumnActions.subscribe((columnAction) =>
    //   this.handleItemAction(columnAction)
    // );

  }

  handleItemAction(cardAction: any) {
    const { action, row } = cardAction;
    // this.servicePanelDataSource.
  }

  public trackByFn(index: number, item: any): any {
    return item.id; // Asume que cada elemento tiene un campo 'id' único
  }

  // public ngOnInit() : void {
  //   this.notificationService.getNotifications(this.getLastHours()).subscribe((res : IAlertHistoryModel[]) => {
  //     this.notifications = res
  //   })
  //   // this.subscription = this.notificationService.currentNotifications$.subscribe((res : IAlertModel) => {
  //   //   if(this.notifications){
  //   //     this.notifications.push(res)
  //   //   }
  //   // })
  // }

  getLastHours(): string {
    const date = new Date();
    const timeCalc = 1000 * 60 * 60 * 24;
    const resultDate = date.getTime() - timeCalc;
    const dateFilter = new Date(resultDate);
    const objDate = isoFormatDate(dateFilter)
    return objDate.fullDate;
  }
}
